// extracted by mini-css-extract-plugin
module.exports = {"desText":"read-more_desText__2YymI","up":"read-more_up__3IpMV","readMore":"read-more_readMore__1Y0Ag","truncate":"read-more_truncate__2lZwL"};